export default __webpack_public_path__ + "static/media/girl-magicband.b563c073.jpg";